async function setUserStatusAttribute(segment) {
  if (!segment) return;

  try {
    const res = await fetch('cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: {
          customerSegment: segment,
        },
      }),
    });

		// if(res.ok){
    //   console.log(res)
		// 	console.log('Cart attributes updated with user segment:', segment);
		// }
		
  } catch (e) {
    console.log('Failed to update cart attributes:', e);
  }
}


window.addEventListener('customerSegment:updated', (e) => {
  //console.log('Received customerSegment:updated event with segment:', e.detail);
  setUserStatusAttribute(e.detail.segment);
});
